import { ButtonBase } from "@reusejs/react";
import VideoCameraSvg from "../../Icons/VideoCameraSvg";
import CostBenefitSvg from "../../Icons/CostBenefitSvg";
import CredibleSellersSvg from "../../Icons/CredibleSellersSvg";
import HassleFreeProcessSvg from "../../Icons/HassleFreeProcessSvg";
import SectionHeading from "../SectionHeading";
import {
  SectionContainerBase,
  TwoColumnSectionBase,
  CenteredGridBase,
  IconTitleDescriptionActionCard,
} from "@reusejs/react";

let firstSectionData = {
  title: "Benefits of buying Auctioned Properties",
  description: "",
};

const Icon = (props: any) => {
  return (
    <div className="flex items-center justify-center h-12 w-12 rounded-md bg-blue-100 text-blue-600">
      {props.iconObject}
    </div>
  );
};

const items = [
  {
    title: "Cost Benefit",
    description:
      "Bank auction properties are potentially 20-30% cheaper than the prevailing market price",
    icon: <Icon iconObject={<CostBenefitSvg />} />,
  },
  {
    title: "Credible Sellers",
    description:
      "The bank/financial institutions are authorized by Govt. of India. Hence it is safe to purchase such properties.",

    icon: <Icon iconObject={<CredibleSellersSvg />} />,
  },
  {
    title: "Hassle-Free Process",
    description:
      "The buyer will have a lesser burden of going through the legal liabilities of the property.",
    icon: <Icon iconObject={<HassleFreeProcessSvg />} />,
  },
];

const FirstSectionAction = () => {
  return (
    <div className="flex flex-col-reverse mt-12 lg:mt-4  lg:flex-row  ">
      <div className="mt-3 lg:mr-2">
        <ButtonBase
          variant="primary"
          type="submit"
          label="Talk to our Expert"
          onClick={() => {
            console.log("button clicked");
          }}
          buttonBaseClasses={{
            font: "text-sm font-medium",
            backgroundColor: "bg-blue-600 hover:bg-blue-700",
            textColor: "text-white",
            border: "any",
            padding: "px-4 py-3",
            width: "w-full lg:w-[initial]",
          }}
        />
      </div>
      <div className="mt-3">
        <ButtonBase
          variant="primary"
          type="submit"
          label="Watch video"
          buttonPrefix={
            <div className="ml-1 mr-2">
              <VideoCameraSvg />
            </div>
          }
          onClick={() => {
            console.log("button clicked");
          }}
          buttonBaseClasses={{
            font: "text-sm font-medium",
            backgroundColor: "bg-transparent",
            textColor: "text-black hover:text-blue-700",
            padding: "px-4 py-3",
            border: "border border-black border hover:border-blue-700",
            width: "w-full lg:w-[initial]",
          }}
        />
      </div>
    </div>
  );
};

const FirstSection = (props: any) => {
  return (
    <SectionHeading
      title={firstSectionData.title}
      description={firstSectionData.description}
      actions={
        <div className="hidden md:block">
          <FirstSectionAction />
        </div>
      }
      itemTitleDescriptionCardBaseClasses={{
        titleWrapper: "mt-2 text-left",
        titleStyles:
          "w-11/12 text-2xl lg:text-3xl font-extrabold tracking-tight sm:text-4xl ",
        descriptionWrapper: "text-left mt-2",
        descriptionStyles: "text-base text-gray-500",
        actionWrapper: "mt-2 text-left text-blue-600",
      }}
    />
  );
};

const ItemRendererComponent = (props?: any) => {
  return (
    <>
      {props.items.map((item?: any, index?: number) => {
        return (
          <div key={`${index}_main`}>
            <div className="block lg:hidden" key={`${index}_1`}>
              <IconTitleDescriptionActionCard
                key={index}
                title={item.title}
                icon={item.icon}
                description={item.description}
                iconPosition="top-left"
                itemTitleDescriptionCardBaseClasses={{
                  iconWrapper:
                    "flex h-12 w-12 items-center justify-center rounded-md text-white",
                  titleWrapper: "mt-5 text-left",
                  titleStyles:
                    "text-lg leading-6 font-bold md:font-medium text-gray-900",
                  descriptionWrapper: "text-left mt-2",
                  descriptionStyles: "text-sm md:text-base text-gray-500",
                  actionWrapper: "mt-2 text-left",
                }}
              />
            </div>
            <div className="hidden lg:block" key={`${index}_2`}>
              <IconTitleDescriptionActionCard
                key={index}
                title={item.title}
                icon={item.icon}
                description={item.description}
                iconPosition="left"
                itemTitleDescriptionCardBaseClasses={{
                  iconWrapper:
                    "flex h-12 w-12 items-center justify-center rounded-md text-white",
                  titleWrapper: "mt-5 text-left",
                  titleStyles:
                    "text-lg leading-6 font-bold md:font-medium text-gray-900",
                  descriptionWrapper: "text-left mt-2",
                  descriptionStyles: "text-sm md:text-base text-gray-500",
                  actionWrapper: "mt-2 text-left",
                }}
              />
            </div>
          </div>
        );
      })}
    </>
  );
};

const SecondSection = (props: any) => {
  return (
    <>
      <CenteredGridBase
        items={items}
        itemsRenderer={ItemRendererComponent}
        centeredGridBaseClasses={{
          gridClasses:
            "space-y-10 sm:space-y-0 sm:grid sm:grid-cols-1 sm:gap-x-8 sm:gap-y-4",
        }}
      />
      <div className="block w-full md:hidden">
        <FirstSectionAction />
      </div>
    </>
  );
};

export default function BenefitsComponent() {
  return (
    <SectionContainerBase
      sectionContainerBaseClasses={{
        outerContainerStyles:
          "py-10 md:py-20 bg-slate-50 border-b overflow-hidden",
        innerContainerStyles: "relative max-w-7xl mx-auto px-6 lg:px-8",
      }}
    >
      <TwoColumnSectionBase
        firstColumnEl={<FirstSection />}
        secondColumnEl={<SecondSection />}
        twoColumnSectionBaseClasses={{
          firstElWrapperStyles: "w-full md:w-1/2",
          secondElWrapperStyles: "w-full md:w-1/2 self-stretch md:pl-16",
          columnsFlexWrapperStyles:
            "flex items-center justify-between flex-col md:flex-row",
        }}
      />
    </SectionContainerBase>
  );
}
